import {UiLibService} from "../../ui-lib.service";

export class UiLogger {

  static debug: boolean;

  public static log(id: string,message: string): void {

    if (UiLogger.debug == true) {
      console.log(`${id} => ${message}`);
    }
  }

  public static initializeDebugMode(uiLibService: UiLibService) {
    UiLogger.debug = uiLibService.getConfig().debug;
  }

}


